import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { setfeedbackPopup } from "../../../redux/features/stylesSlice";
import {
  emailValidation,
  notEmptyValidation,
} from "../../../functions/validation";
import InputText from "../../../components/input/InputText";
import InputArea from "../../../components/input/InputArea";
import InputCheckbox from "../../../components/input/InputCheckbox";
import Rating from "react-rating";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { getConfig, searchAPI } from "../../../apis";
import { logEvent } from "../../../functions/amplitude";
import { axiosInstance } from "../../../functions/axios";

const PopupFeedback = () => {
  const dispatch = useDispatch();
  const { feedbackPopup } = useSelector((state) => state.styles);
  const { user } = useSelector((state) => state.auth);

  const [rating, setrating] = useState(0);
  const [improvement, setimprovement] = useState("");
  const [like, setlike] = useState("");

  const [anonymous, setanonymous] = useState(false);

  const [loading, setloading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();

    if (rating === 0) {
      toast.error("Please fill the rating to submit this form.");

      return null;
    }
    setloading(true);

    try {
      const res = await axiosInstance.post(
        searchAPI.feedback,
        {
          feedbackImprovement: improvement,
          feedbackText: like,
          numStars: rating,
          isAnonymous: user ? anonymous : true,
          lastUpdatedByUserId: user ? user.userId : null,
        },
        getConfig()
      );

      setloading(false);

      toast.success("Feedback sent successfully");

      dispatch(setfeedbackPopup(false));
    } catch (error) {
      console.log(error);
      setloading(false);

      toast.error("Something went wrong, please try again later");
    }

    logEvent("submit_feedback", { feedback: "submitted" });
  }

  useEffect(() => {
    if (feedbackPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      setrating(0);
      setimprovement("");
      setlike("");
      setanonymous(false);
    }
  }, [feedbackPopup]);

  return (
    <>
      {feedbackPopup && <div className="bg-dark-feedback" />}
      <div className={`popup-feedback ${feedbackPopup ? "active" : ""}`}>
        <div
          className="cross"
          onClick={() => dispatch(setfeedbackPopup(false))}
        >
          <CloseIcon />
        </div>
        <h1 className="contact">We love feedback!</h1>
        <h3 className="desc">
          Your feedback on Sooth is greatly appreciated. We read everything you
          share with us.
        </h3>
        <div className="ratings">
          <p>What's your experience so far?</p>
          <Rating
            emptySymbol={<StarBorderIcon />}
            fullSymbol={<StarIcon />}
            onChange={(val) => setrating(val)}
            initialRating={rating}
          />
        </div>
        <InputArea
          label="What needs improvement?"
          placeholder="What needs improvement?"
          value={improvement}
          onChange={(e) => setimprovement(e.target.value)}
        />
        <InputArea
          label="What do you like?"
          placeholder="What do you like?"
          value={like}
          onChange={(e) => setlike(e.target.value)}
        />
        {user && (
          <InputCheckbox
            label="Please keep my feedback anonymous"
            value={anonymous}
            onChange={(e) => setanonymous(e.target.checked)}
          />
        )}
        <ButtonPrimary text="Submit" onClick={onSubmit} loading={loading} />
      </div>
    </>
  );
};

export default PopupFeedback;
